import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import ConcalLogo from '../../../components/ConcalLogo';

const PreAuthHeader = () => {
  const handleSupport = () => {
    // Mock support functionality
    window.open('mailto:support@contractparser.com', '_blank');
  };

  const handleDocumentation = () => {
    // Mock documentation link
    alert('Documentation would open in a new tab');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-navigation bg-card/80 backdrop-blur-md border-b border-border/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-16 px-6">
          {/* Logo */}
          <div className="flex items-center">
            <ConcalLogo size="default" />
          </div>

          {/* Navigation Links */}
          <nav className="hidden md:flex items-center space-x-6">
            <button
              onClick={handleDocumentation}
              className="text-muted-foreground hover:text-foreground font-body text-sm font-medium transition-colors duration-200"
            >
              Documentation
            </button>
            <button
              onClick={handleSupport}
              className="text-muted-foreground hover:text-foreground font-body text-sm font-medium transition-colors duration-200"
            >
              Support
            </button>
          </nav>

          {/* Support Button */}
          <div className="flex items-center space-x-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={handleSupport}
              iconName="HelpCircle"
              iconPosition="left"
              iconSize={16}
              className="hidden sm:flex"
            >
              Help
            </Button>
            
            {/* Mobile Support */}
            <button
              onClick={handleSupport}
              className="sm:hidden p-2 rounded-lg hover:bg-muted transition-colors duration-200"
              aria-label="Get help"
            >
              <Icon name="HelpCircle" size={20} color="var(--color-muted-foreground)" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default PreAuthHeader;